import { useState } from 'react'
import { motion } from 'framer-motion'
import { Image, useMaxWidth } from '@tracklib/kit'
import styles from './partneranimation.css'

const variants = {
  hide: { x: '200%', rotate: 30 },
  show: { x: 0, rotate: 0 },
}

const mobileVariants = {
  hide: { opacity: 0 },
  show: { opacity: 1 },
}

const PartnerAnimation = ({ image }: { image: string }): JSX.Element => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const isSmall = useMaxWidth()
  const timing = isSmall ? 1 : 1.2
  return (
    <div className={styles.partnerAnimation}>
      <motion.div
        className={styles.partnerImageWrapper}
        initial="hide"
        animate={imageLoaded ? 'show' : 'hide'}
        variants={isSmall ? mobileVariants : variants}
        transition={{ ease: [0.33, 0.52, 0.2, 1], duration: timing }}
      >
        <Image image={image} alt="" absolute className={styles.partnerImage} onLoad={() => setImageLoaded(true)} />
      </motion.div>
      <motion.div
        className={styles.holo}
        initial={{ scale: isSmall ? 1 : 1.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{
          scale: { delay: isSmall ? 0 : timing - 0.2, type: 'spring', bounce: 0.4 },
          opacity: { delay: isSmall ? 0 : timing - 0.2, ease: [0.33, 0.52, 0.2, 0.99], duration: timing },
        }}
      />
    </div>
  )
}

export default PartnerAnimation
